import React from 'react'
import withSignUpLayout, { WithSignUpLayout } from 'containers/hoc/withSignUpLayout'
import { useDispatch } from 'react-redux'
import { useApiErrors } from 'core/services/suggPro/useApiErrors'
import { useEstablishmentUpdate } from '@sugg-gestion/ubidreams-react-suggpro'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { redirectToEstablishment } from 'core/store/app/actions'
import EstablishmentHoursView from 'components/views/establishment/establishmentHoursView'
import { HoursFormState } from 'components/forms/establishment/hoursForm'
import withMuiPickersUtilsProvider from '../hoc/withMuiPickersUtilsProvider'

interface Props extends WithSignUpLayout {
    step?: number
    steps?: number
}

const EstablishmentAddHours: React.FC<Props> = ({ establishment, step = 6, steps = 8 }) => {
    const { enqueueSnackbar } = useSnackbar()
    const { t } = useTranslation()

    const dispatch = useDispatch()

    const { displayError } = useApiErrors()
    const { updateEstablishment, inProgress } = useEstablishmentUpdate()
    const { updateEstablishment: updateToPreviousStatus, inProgress: updateToPreviousStatusInProgress } =
        useEstablishmentUpdate()

    const handleUpdateHours = (values: HoursFormState) => {
        updateEstablishment({
            id: establishment.id,
            establishment: {
                businessHours: values.regularHours,
            },
            nextStatus: 'PHOTOS',
        })
            .then(() => {
                enqueueSnackbar(t('views.establishment.hours.success'), {
                    variant: 'success',
                })
                dispatch(redirectToEstablishment())
            })
            .catch((error) => displayError(error))
    }

    const handlePrevious = () => {
        updateToPreviousStatus({
            id: establishment.id,
            establishment: {},
            nextStatus: 'LOCATION',
        })
            .then(() => {
                dispatch(redirectToEstablishment())
            })
            .catch((error) => displayError(error))
    }

    return (
        <EstablishmentHoursView
            step={step}
            steps={steps}
            onSubmit={handleUpdateHours}
            inProgress={inProgress}
            initialValues={{
                regularHours: establishment.businessHours ?? undefined,
            }}
            previousInProgress={updateToPreviousStatusInProgress}
            onPrevious={handlePrevious}
        />
    )
}

export default withMuiPickersUtilsProvider(withSignUpLayout(EstablishmentAddHours))
